import React from "react";
import {
  TextInput,
  // ImageInput,
  // Notification,
  // minLength,
  // maxLength,
  // useQueryWithStore,
} from "react-admin";

// import Icon from "@material-ui/core/Icon";

// import { green } from "@material-ui/core/colors";

import // CheckboxGroupInput,
// regex,
// email,
// required,
// AutocompleteArrayInput,
"react-admin";
// import clsx from 'clsx';
// import GoogleLogin from "react-google-login";
// import { Form, Field } from "react-final-form";
// import { useAuthProvider } from "react-admin";
// import { TextField, Checkbox } from "final-form-material-ui";
import Button from "@material-ui/core/Button";
// import { makeStyles } from "@material-ui/core/styles";
// import Snackbar from "@material-ui/core/Snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { SelectInput } from "react-admin";
// import { PasswordInput } from "react-admin";
// import { makeStyles } from '@material-ui/core/styles';
// import { DropDownList } from '@progress/kendo-react-dropdowns';
import {
  Paper,
  Grid,
  // CssBaseline,
  // FormControlLabel
} from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";

// const useStyles = makeStyles((theme) => ({
//   "@global": {
//     body: {
//       backgroundColor: theme.palette.common.white,
//     },
//   },
//   RaFileInput: {
//     marginTop: "5px",
//     height: "20px",
//     width: "20px",
//     borderRadius: "50%",
//     // marginRight:"auto",
//     // marginLeft:"100px",
//     // display:"block",
//     display: "flex",
//     margin: "auto",
//   },
//   placeholder: {
//     color: "red",
//     opacity: 1 /* Firefox */,
//   },
//   googleIcon: {
//     width: 30,
//     marginRight: theme.spacing(2),
//   },
//   AddIcon: {
//     width: 30,
//     marginTop: "25px",
//     padding: "0px",
//     marginLeft: "50px",
//   },
//   googleButton: {
//     marginTop: "-25px",
//     // boxShadow: theme.customShadows.widget,
//     backgroundColor: "white",
//     width: "100%",
//     textTransform: "none",
//     textAlign: "center",
//     fontFamily: "Larsseit,Helvetica,Arial,Lucida,sans-serif",
//   },
//   styles: {
//     image: { maxHeight: "3rem" },
//   },
// }));

export const FeedbackForm = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest
}) => {
  // const classes = useStyles();

  console.log("values", values);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper style={{ padding: 5, boxShadow: "none" }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Rating
              name="hover-feedback"
              label="Feedback"
              source="feedback-rating"
              onChange={(e) => {
                console.log("rate", e.target.value);
                values.rate = e.target.value
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              multiline
              source="feedback"
              variant="standard"
              fullWidth
              label="Enter Your Feedback"
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={submitting}
              style={{ width: "100%" }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};
